import { doGETRequest , doPUTRequest, doPOSTRequest} from "./Api";

 interface ActuatorInfo {info: {
     app: {version: string;}
   }
  }

class UserAccessApi {

  public static async signIn(signInForm: any) {
    const relativePath = "/user-access/sign-in";
    var response = await doPOSTRequest(relativePath, signInForm);
    return response;
  }

  public static async createOrUpdateUser(userData: any) {
    const relativePath = "/user-access";
    if(userData.id) {
      return this.updateUser(userData);
    }
    return this.createUser(userData);
  }
  
  public static async createUser(createUserData: any) {
    const relativePath = "/user-access";
    var response = await doPOSTRequest(relativePath, createUserData);
    return response;
  }

  public static async getAppVersion(): Promise<string> {
    const relativePath = "/actuator/info";
    const response = await doGETRequest(relativePath);

    console.log("WrappedResponse:", response);

    if (!response.success || !response.data) {
      throw new Error("Failed to fetch app version");
    }

    const actuatorData = response.data; // { version: "0.1.0" }
    console.log("Actuator Data:", actuatorData);

    return actuatorData.version; // artık doğru
  }


  public static async updateUser(updateUserData: any) {
    const relativePath = "/user-access";
    var response = await doPUTRequest(relativePath, updateUserData);
    return response;
  }

  public static async listAll() {
    const relativePath = "/user-access";
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async listAllRoles() {
    const relativePath = "/user-access/roles";
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async listRolesOfUser(userAccessId: String) {
    const relativePath = "/user-access/roles?userAccessId="+userAccessId;
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async generatePass(userAccessId: String) {
    const relativePath = "/user-access/generate-pass?userAccessId="+userAccessId;
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async listUsersByRole(roleStr?: string) {
    const relativePath = roleStr
      ? `/user-access/users-by-roles?role=${roleStr}`
      : `/user-access/users-by-roles`;

    const response = await doGETRequest(relativePath);
    return response;
  }

}

export default UserAccessApi;
